/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */

import { FooterBlock } from './FooterBlock';

export default FooterBlock;

/**
 * @deprecated Use `import { FooterBlock } from '@atlaskit/smart-card/footer-block'` instead.
 */
export { FooterBlock } from './FooterBlock';
